import React, {useCallback, useEffect, useState, useRef} from 'react';
import {onlineProcessesService} from '../../../services';

import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralButtonIcon from '@quadral/quadral-component-common/dist/components/buttonIcon'
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography';
import SupportingDocumentList from './supportingDocumentDetail/SupportingDocumentList';
import SupportingDocumentDetail from './supportingDocumentDetail/SupportingDocumentDetail';
// import ImportingDocuments from './importingDocument/ImportingDocuments';
import ReceptionBox from './supportingDocumentDetail/ReceptionBox';
import AddDocumentModal from './supportingDocumentDetail/AddDocumentModal';
import {
    faBars,
    faCheck,
    faFileInvoice,
    faLink,
    faPencil,
    faSlash,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {QuadralLoaderProvider} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import AddNewDocumentModal from './supportingDocumentDetail/AddNewDocumentModal';
import AICheckModal from './supportingDocumentDetail/AICheckModal';
import ForceUploadModal from "./supportingDocumentDetail/ForceUploadModal";
import SendMailModal from "../SendMailModal";
import {themeColors} from "../../../theme/themeConstants";

export default function SupportingDocuments({
                                                updatedData,
                                                setUpdatedData,
                                                personIds,
                                                roles,
                                                participation,
                                                showLoader,
                                                hideLoader,
                                                setSupportingDocuments,
                                                ...props
                                            }) {
    const [data, setData] = useState([]);
    const [flatenedData, setFlatenedData] = useState([]);
    const [receptionBox, setReceptionBox] = useState([]);
    const [displayDocumentList, setDisplayDocumentList] = useState(true);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [documentOrder, setDocumentOrder] = useState(1);
    const [selectedCurrentPerson, setSelectedCurrentPerson] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [receptionBoxDisplay, setReceptionBoxDisplay] = useState(false);
    const [associationDisplay, setAssociationDisplay] = useState(false);
    const [supportingDocsOnly, setSupportingDocsOnly] = useState();
    const [notDeletedPersons, setNotDeletedPersons] = useState([]);

    const [nationalityLabel, setNationalityLabel] = useState([]);
    const [categoryLabel, setCategoryLabel] = useState([]);
    const [typeLabel, setTypeLabel] = useState([]);
    const [statusLabel, setStatusLabel] = useState([]);
    const [allVialinkChecked, setAllVialinkChecked] = useState(false)
    // const [personsToCheck, setPersonsToCheck] = useState([]);
    // const [updatedStatus, setUpdatedStatus] = useState([]);
    const [updatedDocumentId, setUpdatedDocumentId] = useState([]);
    const [rotatedFiles, setRotatedFiles] = useState({})

    const [files, setFiles] = useState([]);
    const [hasReceptionFiles, setHasReceptionFiles] = useState(false);
    const [showAssociateButton, setShowAssociateButton] = useState(false);
    const [showAIVerification, setShowAIVerification] = useState(false);

    const [addDocModalOpen, setAddDocModalOpen] = useState(false);
    const [addNewDocModalOpen, setAddNewDocModalOpen] = useState(false);
    const [aiCheckModal, setAICheckModal] = useState(false);
    const [selectedUnattachedFile, setSelectedUnattachedFile] = useState([]);
    const [selectedFileByDoc, setSelectedFileByDoc] = useState({});
    const [allUnassignedDocs, setAllUnassignedDocs] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [isAnySelected , setIsAnySelected] = useState(false);
    const [unassignedAndSelected, setUnassignedAndSelected] = useState([]);
    const [forceUploadModalOpen, setForceUploadModalOpen] = useState(false);
    const [isAssignation, setIsAssignation] = useState(false);
    const [sendMailModalOpen, setSendMailModalOpen]= useState(false);

    const [completedRows, setCompletedRows] = useState({});

    const [status, setStatus] = useState('');
    const [statusIcon, setStatusIcon] = useState('');
    const [showRefuseModal, setShowRefuseModal] = useState(false);
    const [refuseFormData, setRefuseFormData] = useState({
        refusalReason: '',
        refusalReasonDetails: '',
        category: selectedDocument?.category || '',
        personId: selectedDocument?.personId || '',
        status: ''
    });

    const isFirstLoadRef = useRef(true);

    /*---------------------------------------BOX RECEPTION (ASSIGNATION)----------------------------------------*/

    useEffect(() => {
        if (selectedCurrentPerson === 'receptionBox') {
            setReceptionBoxDisplay(true)
        } else {
            setReceptionBoxDisplay(false)
        }
    }, [selectedCurrentPerson, selectedIndex]);

    useEffect(() => {
        ((["en_attente_des_pj", "complements_attendu", "controle_en_cours", "complements_fournis"]?.includes(participation?.status)) &&
        (roles?.includes("survey-participation.write")))
            ?
            setShowAIVerification(true)
            :
            setShowAIVerification(false)
    }, [participation?.status, roles]);

    useEffect(() => {
        const validPersons = props?.persons?.filter(p => p.status !== "supprime")
        setNotDeletedPersons(validPersons);
    }, [props.persons]);

    function handlePageAssignment(docId, pages) {
        setSelectedFileByDoc(prev => {
            const updated = {...prev};
            const existing = updated[docId] || [];
            const newPages = Array.isArray(pages) ? pages : [pages];
            const filteredPages = newPages.filter(p => !Object.values(prev).flat().some(existingPage => existingPage.index === p.index));
            updated[docId] = [...existing, ...filteredPages];
            return updated;
        });
    }

    function handlePageDissociation(docId) {
        setSelectedFileByDoc(prev => {
            const updated = {...prev};
            delete updated[docId];
            return updated;
        });
    }

    function handlePageSelection(checked, page) {
        if (checked) {
            setSelectedUnattachedFile(prev => {
                const alreadyExists = prev.some(p => p.index === page.index)
                if (alreadyExists) return prev;

                return [
                    ...prev,
                    page
                ];
            })
        } else {
            setSelectedUnattachedFile(prev => prev.filter(p => p.index !== page.index))
        }
    }

    function getSupportingDocumentTypeByPerson(personId) {
        return flatenedData.filter(doc => doc.personId === personId && doc.status === "a_fournir")
            .map(doc => ({id: doc.id, type: doc.type})).filter((type, index, self) => self.indexOf(type) === index);
    }

    function getSupportingDocumentCategoryByPerson(personId) {
        return flatenedData.filter(doc => doc.personId === personId && doc.status === "a_fournir")
            .map(doc => ({
                id: doc.id,
                category: doc.category
            })).filter((category, index, self) => self.indexOf(category) === index);
    }

    /*-------------------------------------BOX RECEPTION (ALL SELECT BUTTON)-----------------------------------*/

    function makePageId(selectedIndex, documentIndex, pageIndex) {
        return `${selectedIndex}-${documentIndex}-${pageIndex + 1}`
    }

    useEffect(() => {
        if (!receptionBox?.length) {
            setAllUnassignedDocs([]);
            return;
        }

        if (selectedIndex === null) {
            setAllUnassignedDocs([]);
            return;
        }

        const assignedIndexes = Object.values(selectedFileByDoc || {}).flat().map(p => p.index);

        const selectedDoc = receptionBox[selectedIndex];
        if (!selectedDoc || !selectedDoc.files) {
            setAllUnassignedDocs([]);
            return;
        }

        const allFiles = selectedDoc.files.map((page, pageIndex) => ({
            index: makePageId(selectedIndex, selectedIndex, pageIndex),
            alt: `${selectedDoc.name} - Page ${pageIndex + 1}`,
            src: `data:${page.mimeType};base64,${page.data}`,
            documentName: selectedDoc.name,
            documentIndex: selectedIndex
        })).filter(p => !assignedIndexes.includes(p.index));

        setAllUnassignedDocs(allFiles);
    }, [receptionBox, selectedFileByDoc, selectedIndex]);

    useEffect(() => {
        if (!allUnassignedDocs?.length) {
            setAllSelected(false);
            return;
        }
        const selectedSet = new Set((unassignedAndSelected || []).map(p => p.index));
        const everySelected = allUnassignedDocs.every(p => selectedSet.has(p.index));
        setAllSelected(everySelected);
        setIsAnySelected(selectedSet.size);
    }, [allUnassignedDocs, unassignedAndSelected]);

    useEffect(() => {
        const assignedIndexes = Object.values(selectedFileByDoc || {}).flat().map(p => p.index);
        const unassignedSelectedUnattachedFiles = selectedUnattachedFile?.filter(p => !assignedIndexes.includes(p.index));
        setUnassignedAndSelected(unassignedSelectedUnattachedFiles);
    }, [selectedUnattachedFile, selectedFileByDoc]);

    function toggleSelectAll(checked) {
        if (checked) {
            setSelectedUnattachedFile(prev => {
                const existingIndexes = new Set(prev.map(p => p.index));
                const newSelections = allUnassignedDocs.filter(doc => !existingIndexes.has(doc.index));
                return [...prev, ...newSelections];
            });
        } else {
            setSelectedUnattachedFile(prev => {
                const currentPageIndexes = new Set(allUnassignedDocs.map(p => p.index));
                return prev.filter(p => !currentPageIndexes.has(p.index));
            });
        }
        setAllSelected(checked);
    }

    /*-----------------------------------------UPLOAD (FILE CONVERSION)-------------------------------------*/

    function dataUrlToFile(dataUrl, filename) {
        const arr = dataUrl.split(',');

        const mimeMatch = dataUrl.match(/^data:(.+?);/);
        const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
        let extension = mimeType.split('/')[1] || 'bin';
        if (extension === 'jpeg') extension = 'jpg';

        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let safeName = filename;
        if (!safeName.toLowerCase().endsWith(`.${extension}`)) safeName += `.${extension}`;
        return new File([u8arr], safeName, {type: mimeType});
    }

    function matchPersonId(docId) {
        for (const personKey in data) {
            for (const doc of data[personKey] || []) {
                if (doc.id === docId) {
                    return doc.personId;
                }
            }
        }
        return null;
    }

    function buildRequest({selectedFileByDoc, dataMap, participationId}) {
        const requests = [];

        for (const [docId, files] of Object.entries(selectedFileByDoc || {})) {
            const personId = matchPersonId(docId, dataMap);
            if (!personId || !Array.isArray(files) || files.length === 0) {
                console.warn('personId ou flies manquant')
                continue;
            }

            const formData = new FormData();
            files.forEach((item, i) => {
                const fieldName = i === 0 ? 'file' : `file${i + 1}`;
                let fileToUpload = item;

                if (typeof item === "string" && item.startsWith('data:')) {
                    fileToUpload = dataUrlToFile(item, `file${i + 1}`);
                } else if (item && typeof item === 'object' && item.src?.startsWith('data:')) {
                    fileToUpload = dataUrlToFile(item.src, item.alt || `file${i + 1}`);
                }
                formData.append(fieldName, fileToUpload);
            })

            requests.push({
                params: {
                    participationId,
                    personRecordId: personId,
                    supportingDocumentId: docId
                }, formData
            });
        }

        return requests;
    }

    function confirmAssignation({force = false, rotatedFiles = null} = {}) {
        showLoader();
        setIsAssignation(true);
        const selectedFiles = rotatedFiles ? rotatedFiles : selectedFileByDoc;
        const reqs = buildRequest({
            selectedFileByDoc: selectedFiles,
            dataMap: data,
            participationId: participation?.id
        });

        /*--------------------------------------------UPLOAD (CALL API)------------------------------------------*/

        Promise.all(
            reqs.map(({params, formData}) => {
                const uploadParams = {...params, forceUpload: force};
                return onlineProcessesService.uploadSupportingDocumentFile(uploadParams, formData)
                    .then(() => ({ok: true, params: uploadParams}))
                    .catch(error => {
                        console.error('Upload échoué', uploadParams, error);
                        return {ok: false, params: uploadParams, error};
                    });
            })
        )
            .then(results => {
                const fails = results.filter(result => !result.ok).length;
                const rowCompleted = (allUnassignedDocs.length === 0);
                setCompletedRows(prev => ({...prev, [selectedIndex]: rowCompleted}));

                if (fails === 0) {
                    props.updateData();
                    setSelectedUnattachedFile([]);
                    setSelectedFileByDoc({});
                    props.quadralToast.success('Tous les fichiers ont été ajoutés avec succès.');
                } else {
                    const hasForceUploadError = results.some(result =>
                        !result.ok &&
                        result.error?.response?.status === 400 &&
                        result.error?.response?.data?.message?.startsWith('Mauvais type de document téléversé')
                    );

                    if (hasForceUploadError) {
                        setForceUploadModalOpen(true);
                    } else {
                        deleteUploadedDocuments();
                        props.quadralToast.error('Erreur lors de l\'assignation.');
                    }
                }
            })
            .finally(() => {
                hideLoader();
            });
    }

    async function deleteUploadedDocuments() {
        showLoader();
        const selectedFiles = rotatedFiles ? rotatedFiles : selectedFileByDoc;
        const reqs = buildRequest({
            selectedFileByDoc: selectedFiles,
            dataMap: data,
            participationId: participation?.id
        });
        await Promise.all(
            reqs.map(({params}) =>
                onlineProcessesService.deleteSupportingDocument(params)
            )
        )
        hideLoader();
    }

    /*----------------------------------------------GET REFERENCES-------------------------------------------*/

    useEffect(() => {
        onlineProcessesService.getSupportingDocReferences().then(data => {
            setCategoryLabel(data?.SUPPORTING_DOCUMENT_CATEGORY)
            setStatusLabel(data?.SUPPORTING_DOCUMENT_STATUS)
            const documentTypeKeys = Object.keys(data || {}).filter(
                key => key !== 'SUPPORTING_DOCUMENT_CATEGORY' && key !== 'SUPPORTING_DOCUMENT_STATUS' && key !== 'SUPPORTING_DOCUMENT_REFUSAL_REASON'
            );
            const mergedDocumentTypes = documentTypeKeys.flatMap(key => data[key]);
            setTypeLabel(mergedDocumentTypes);
        })
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        setNationalityLabel(props.references?.PERSON_RECORD_NATIONALITY)
    }, [props.references]);

    /*----------------------------------------------SUPPORTING DOCUMENTS------------------------------------------*/

    function createNewSupportingDocument(participationId, personRecordId, category) {
        const newSupportingDocument = {
            category: category,
            type: selectedDocument?.type,
            personId: personRecordId,
            status: 'a_fournir'
        };

        onlineProcessesService.createSupportingDocument({participationId, personRecordId}, newSupportingDocument)
            .then(response => props?.hideLoader())
            .catch(error => props?.hideLoader());
    }

    function updateSupportingDocument() {
        props?.showLoader();
        const participationId = participation?.id;
        const personRecordId = selectedDocument?.personId;
        const supportingDocumentId = selectedDocument?.id;
        const category = selectedDocument?.category;

        setRefuseFormData(prevState => {
            const updatedFormData = {
                ...prevState,
                category: category || '',
                personId: personRecordId || '',
                status: 'refuse'
            };

            onlineProcessesService.updateSupportingDocument({
                participationId,
                personRecordId,
                supportingDocumentId
            }, updatedFormData)
                .then(response => {
                    props?.hideLoader();
                    setShowRefuseModal(false);
                    setStatus('Refusé');
                    setStatusIcon(getStatusIcon(updatedFormData));
                    const updatedData = {...data};

                    updatedData[selectedCurrentPerson] = updatedData[selectedCurrentPerson].map(doc => {
                        if (doc.id === supportingDocumentId) {
                            return {
                                ...doc,
                                status: 'refuse',
                                statusIcon: getStatusIcon(updatedFormData)
                            };
                        }
                        return doc;
                    });

                    setData(updatedData);

                    if (refuseFormData.refusalReason !== "annulee") {
                        createNewSupportingDocument(participationId, personRecordId, category);
                    }

                    props.updateData();
                })
                .catch(error => props?.hideLoader());

            return updatedFormData;
        });
    }

    const getCategory = useCallback((item) => {
        const reference = Array.isArray(categoryLabel) ? categoryLabel.find(ref => ref.code === item?.category) : [];
        return reference ? reference.label : 'Inconnu';
    }, [categoryLabel]);

    function getType(item) {
        const reference = Array.isArray(typeLabel) ? typeLabel.find(ref => ref.code === item?.type) : [];
        return reference ? reference.label : 'Inconnu';
    }

    const getStatus = useCallback((item) => {
        const reference = Array.isArray(statusLabel) ? statusLabel.find(ref => ref.code === item?.status) : [];
        if (item.status === 'a_fournir' && receptionBoxDisplay) return '';
        return reference ? reference.label : 'Inconnu';
    }, [statusLabel, receptionBoxDisplay]);

    function getContextFromCompanyCode(companyCode) {
        const contextMapping = {
            '24': 'batigere',
            '26': 'sedes'
        };

        return contextMapping[companyCode] || null;
    }

    function impersonateToCandidate() {
        showLoader();

        if (!participation?.uniqueContractCode) {
            hideLoader();
            return;
        }

        const context = getContextFromCompanyCode(participation?.companyCode);

        if (!context) {
            hideLoader();
            console.error('Unknown company code:', participation?.companyCode);
            return;
        }

        onlineProcessesService.impersonate(participation?.uniqueContractCode, context)
            .then(response => {
                hideLoader();
                window.open(response, "_blank");
            })
            .catch(err => {
                hideLoader();
                console.error(err);
                props.quadralToast.error('Impossible de renseigner la participation.');
            });
    }


    function AssignmentButtons({
                                   item,
                                   receptionBoxDisplay,
                                   selectedFileByDoc,
                                   selectedUnattachedFile,
                                   onAssign,
                                   onDissociate
                               }) {
        const assignedIndexes = Object.values(selectedFileByDoc || {}).flat().map(p => p.index);
        const canAssociate = selectedUnattachedFile?.filter(p => !assignedIndexes.includes(p.index))?.length > 0;
        const canDissociate = selectedFileByDoc?.[item.id]?.length > 0;

        if (!receptionBoxDisplay) return <FontAwesomeIcon icon={faFileInvoice}/>;

        return (
            <div style={{display: 'flex', gap: '0.25rem', width: '100%', justifyContent: 'end'}}>
                <QuadralButtonIcon
                    size='small'
                    label='card button'
                    title='Associer'
                    disabled={!canAssociate}
                    onClick={(e) => {
                        e.stopPropagation();
                        onAssign(item.id, selectedUnattachedFile);
                    }}
                    icon={<FontAwesomeIcon icon={faLink}/>}
                />
                <QuadralButtonIcon
                    size='small'
                    label='card button'
                    title='Dissocier'
                    disabled={!canDissociate}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDissociate(item.id);
                    }}
                    icon={<FontAwesomeIcon icon={faSlash}/>}
                />
            </div>
        );
    }

    const getStatusIcon = useCallback((item) => {
        if (item.status) {
            switch (item.status) {
                case 'valide':
                    return <FontAwesomeIcon icon={faCheck}/>
                case 'refuse':
                    return <FontAwesomeIcon icon={faXmark}/>
                case 'a_fournir':
                    return (
                        <AssignmentButtons
                            item={item}
                            receptionBoxDisplay={receptionBoxDisplay}
                            selectedFileByDoc={selectedFileByDoc}
                            selectedUnattachedFile={selectedUnattachedFile}
                            onAssign={handlePageAssignment}
                            onDissociate={handlePageDissociation}
                        />
                    );
                default:
                    return <FontAwesomeIcon icon={faFileInvoice}/>;
            }
        }
    }, [receptionBoxDisplay, selectedFileByDoc, selectedUnattachedFile]);

    const getPersonName = useCallback((personId) => {
        if (personId === 'receptionBox') return 'BOITE DE RECEPTION';
        const thePerson = props?.persons?.find(p => personId === p.id);
        return thePerson ? (thePerson?.firstname + ' ' + thePerson?.lastname) : 'Inconnu';
    }, [props?.persons]);

    const getPersonVialinkControlResponse = useCallback(
        (personId) => {
            const person = props?.persons?.find(p => personId === p.id);
            return person ? person?.vialinkControlResponse : '';
        },
        [props?.persons]
    );

    const getPersonGenre = useCallback((personId) => {
        const thePerson = props?.persons?.find(p => personId === p.id);
        if (thePerson?.civility === "Monsieur") return 'M.';
        if (thePerson?.civility === "Madame") return 'Mme';
        return '';
    }, [props?.persons]);

    function getPersonBirthDate(personId) {
        const thePerson = props?.persons?.find(p => personId === p.id);
        return thePerson ? thePerson.birthDate : 'Inconnu';
    }

    function getPersonNationality(personId) {
        const thePerson = props?.persons?.find(p => personId === p.id);
        if (thePerson?.nationality) {
            const reference = Array.isArray(nationalityLabel) ? nationalityLabel.find(ref => ref.code === thePerson?.nationality) : [];
            return reference ? reference.label : 'Inconnu';
        } else {
            return 'Inconnu';
        }
    }

    /*---------------------------------------------GET DATA-------------------------------------------*/

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (!personIds?.length || !participation?.id) return;

        const fetchDocuments = async () => {
            try {
                showLoader();
                
                const promises = [
                    onlineProcessesService.getSplitFiles(participation.id)
                        .then(receptionData => {
                            const safeReceptionData = Array.isArray(receptionData) ? receptionData : [];
                            setReceptionBox(safeReceptionData);

                            const totalFiles = safeReceptionData.reduce((total, doc) => total + (doc.files?.length || 0) + (doc?.isTooLarge ? 1 : 0), 0);

                            if (totalFiles > 0) {
                                setHasReceptionFiles(true);
                                return Promise.resolve({
                                    personId: 'receptionBox',
                                    data: safeReceptionData.map(doc => ({
                                        name: doc.originalDocumentName,
                                        pages: doc.totalOfPages || 0,
                                        files: doc.files,
                                        isTooLarge: doc.isTooLarge
                                    }))
                                });
                            } else {
                                setHasReceptionFiles(false);
                                return Promise.resolve({
                                    personId: 'receptionBox',
                                    data: [{
                                        name: 'Aucun document à traiter en boite de réception',
                                        pages: 0,
                                        files: []
                                    }]
                                });
                            }
                        }),
                    ...personIds.map(personId =>
                        onlineProcessesService.getSupportingDocuments(participation.id, personId)
                            .then((data) => ({personId, data}))
                    )
                ];

                const dataReceived = await Promise.all(promises);
                
                const validDataReceived = dataReceived.filter(item => item && Array.isArray(item.data));
                const filteredData = validDataReceived.filter(({data}) => data.length > 0);

                let globalIndex = 1;
                const flatenedDocs = filteredData.flatMap(({personId, data}) =>
                    data.map((doc) => ({
                        ...doc,
                        personId: personId,
                        globalIndex: personId !== "receptionBox" ? ++globalIndex : 0
                    }))
                );

                setSupportingDocuments(flatenedDocs);
                setFlatenedData(flatenedDocs);

                if (isFirstLoadRef.current && flatenedDocs.length > 0) {
                    isFirstLoadRef.current = false;

                    const receptionDocs = flatenedDocs.filter(doc => doc.personId === 'receptionBox');
                    const supportingDocs = flatenedDocs.filter(doc => doc.personId !== 'receptionBox');

                    let firstDoc;
                    if (supportingDocs.length > 0) {
                        firstDoc = supportingDocs[0];
                    } else if (receptionDocs.length > 0 && receptionDocs.length > 0) {
                        firstDoc = receptionDocs[0];
                    }

                    if (firstDoc) {
                        setSelectedCurrentPerson(firstDoc.personId);
                        setSelectedDocument(firstDoc);
                        setSelectedIndex(0);
                        setDocumentOrder(firstDoc.globalIndex);
                    }
                }

                const onlySupportingDocs = validDataReceived
                    .filter(({personId}) => personId !== "receptionBox")
                    .flatMap(({personId, data}) => data.map(doc => ({
                            ...doc,
                            personId
                        }))
                    );

                setSupportingDocsOnly(onlySupportingDocs);

                const dataByPerson = flatenedDocs.reduce((acc, doc) => {
                    if (!acc[doc.personId]) {
                        acc[doc.personId] = [];
                    }
                    acc[doc.personId].push(doc);
                    return acc;
                }, {});

                setData(dataByPerson);

            } catch (err) {
                console.error('Erreur lors de la récupération des données:', err);
                setData({});
                setFlatenedData([]);
            } finally {
                hideLoader();
            }
        };
        fetchDocuments();
    }, [personIds, participation?.id, updatedData, showLoader, hideLoader, setSupportingDocuments]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        let vialinkControls = [];
        const participationStatus = participation?.status;
        notDeletedPersons?.forEach(person => {
            const vialinkResponse = getPersonVialinkControlResponse(person.id);
            const response = vialinkResponse?.control?.status;
            vialinkControls.push(response);
        });

        if (roles?.includes("survey-participation.write") && ["en_attente_des_pj", "complements_attendu", "controle_en_cours", "complements_fournis"].includes(participationStatus)) {
            setAllVialinkChecked(true);
        } else {
            setAllVialinkChecked(false);
        }
    }, [personIds, participation?.id, participation?.status, roles, updatedData, notDeletedPersons, getPersonVialinkControlResponse]);

    /*-------------------------------------METTRE A JOUR RECEPTION BOX---------------------------------*/

    useEffect(() => {
        const reception = flatenedData.filter(doc => doc.personId === 'receptionBox');
        const receptionDocs = reception?.filter(doc => doc?.pages > 0 || doc?.files?.length > 0);
        setHasReceptionFiles(receptionDocs?.length > 0);
    }, [flatenedData])

    /*-------------------------------------------BUTTONS FUNCTIONS--------------------------------------*/

    function checkByAI() {
        if (allVialinkChecked) setAICheckModal(true);
        // const participationStatus = participation.status;
        //     if(participationStatus === 'en_attente_des_pj'){
        //         setUpdatedStatus('controle_en_cours');
        //     } else if (participationStatus === 'complements_attendu'){
        //         setUpdatedStatus("complements_fournis");
        //     } else {
        //         setUpdatedStatus(participationStatus);
        //     }
    }

    function handleNext() {
        if (selectedCurrentPerson && selectedIndex < data[selectedCurrentPerson].length - 1) {
            setSelectedIndex(selectedIndex + 1)
            setDocumentOrder(documentOrder + 1)
        } else {
            const personIds = Object.keys(data);
            const currentPersonIndex = personIds.indexOf(selectedCurrentPerson);
            if (currentPersonIndex < personIds.length - 1) {
                const nextPersonIds = personIds[currentPersonIndex + 1]
                setSelectedCurrentPerson(nextPersonIds);
                setSelectedIndex(0);
                setDocumentOrder(documentOrder + 1);
            }
        }
    }

    function handleCancel() {
        const personIds = Object.keys(data);
        setSelectedCurrentPerson(personIds[1]);
        setSelectedIndex(0);
        setDocumentOrder(2);
        setSelectedUnattachedFile([]);
    }

    function handlePrevious() {
        if (selectedCurrentPerson && selectedIndex > 0) {
            setSelectedIndex(selectedIndex - 1)
            setDocumentOrder(documentOrder - 1)
        } else {
            const personIds = Object.keys(data);
            const currentPersonIndex = personIds.indexOf(selectedCurrentPerson);
            if (currentPersonIndex > 0) {
                const previousPersonIds = personIds[currentPersonIndex - 1]
                setSelectedCurrentPerson(previousPersonIds);
                setSelectedIndex(data[previousPersonIds].length - 1);
                setDocumentOrder(documentOrder - 1)
            }
        }
    }

    function collapseToggle() {
        setDisplayDocumentList(!displayDocumentList)
    }

    const displayDocumentDetail = useCallback(
        (personId, document, docIndex) => {
            setFiles([]);
            setSelectedUnattachedFile([]);
            setSelectedFileByDoc({});
            setSelectedCurrentPerson(personId)
            setSelectedIndex(docIndex);
            setDocumentOrder(document?.globalIndex);
            setSelectedDocument({...document, personId: document?.personId});
            if (personId === 'receptionBox') {
                const specificDocument = receptionBox.find(doc => doc?.name === document?.name);
                if (specificDocument) {
                    setReceptionBox([specificDocument]);
                }
            }
        },
        [receptionBox]
    );

    const emptyRefusalModal = useCallback(() => {
        setRefuseFormData(formData => ({
            ...formData,
            refusalReason: '',
            refusalReasonDetails: '',
        }));
    }, []);

    /*------------------------------------HANDLE SELECTED DOCUMENT-----------------------------------*/

    useEffect(() => {
        const selection = flatenedData.find(doc => doc.globalIndex === documentOrder);
        setSelectedDocument(selection);
    }, [documentOrder, flatenedData])

    useEffect(() => {
        if (updatedDocumentId === selectedDocument?.id) {
            displayDocumentDetail(selectedCurrentPerson, data[selectedCurrentPerson][selectedIndex], selectedIndex);
        }
        setUpdatedDocumentId('');
    }, [data, selectedCurrentPerson, selectedDocument?.id, updatedDocumentId, selectedIndex, displayDocumentDetail]);

    /*----------------------------------SCROLL & RESPONSIVE------------------------------------------*/

    const deleteSupportingDocument = useCallback(
        () => {
            const valuesAPI = {
                participationId: participation?.id,
                personRecordId: selectedDocument.personId,
                supportingDocumentId: selectedDocument.id,
            };
            onlineProcessesService.deleteSupportingDocument(valuesAPI);
        },
        [participation, selectedDocument]
    );

    useEffect(() => {
        const selectedRow = document.querySelector('.doc-list-row.selected');
        const container = document.querySelector('.supporting-doc-list-detail');
        if (selectedRow && container && window.innerWidth > 1458) {
            const containerRect = container.getBoundingClientRect();
            const rect = selectedRow.getBoundingClientRect();
            const isOutOfView = rect.top < containerRect.top || rect.bottom > containerRect.bottom;
            if (isOutOfView) {
                const scrollOffSet = rect.top - containerRect.top - container.clientHeight / 2
                container.scrollBy(
                    {behavior: 'smooth', top: scrollOffSet}
                )
            }

        }
    }, [selectedIndex, selectedCurrentPerson, deleteSupportingDocument])

    useEffect(() => {
        if (!forceUploadModalOpen && selectedDocument.statusLabel === 'A fournir') {
            deleteSupportingDocument();
            setFiles([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceUploadModalOpen])

    /*--------------------------------------------TEMPLATE-------------------------------------------*/
    return (
        <>
            <SendMailModal
                open={sendMailModalOpen}
                setOpen={setSendMailModalOpen}
                showLoader={showLoader}
                hideLoader={hideLoader}
                participation={participation}
                quadralToast={props.quadralToast}
            />
            <ForceUploadModal
                showLoader={showLoader}
                hideLoader={hideLoader}
                open={forceUploadModalOpen}
                setOpen={setForceUploadModalOpen}
                confirmAssignation={confirmAssignation}
                deleteUploadedDocuments={deleteUploadedDocuments}
                participationId={participation?.id}
                personRecordId={props?.personId}
                supportingDocumentId={props?.document?.id}
                isAssignation={isAssignation}
                setIsAssignation={setIsAssignation}
                rotatedFiles={rotatedFiles}
            />
            <AddDocumentModal
                updateData={props.updateData}
                open={addDocModalOpen}
                setOpen={setAddDocModalOpen}
                persons={notDeletedPersons}
                getSupportingDocumentCategoryByPerson={getSupportingDocumentCategoryByPerson}
                getCategory={getCategory}
                participation={participation}
                showLoader={showLoader}
                hideLoader={hideLoader}
                quadralToast={props.quadralToast}
                setReceptionBox={setReceptionBox}
                signatoryPerson={props?.signatoryPerson}
                setUpdatedDocumentId={setUpdatedDocumentId}
            />
            <AddNewDocumentModal
                associationDisplay={associationDisplay}
                setAssociationDisplay={setAssociationDisplay}
                handlePageAssignment={handlePageAssignment}
                setSelectedFileByDoc={setSelectedFileByDoc}
                dataUrlToFile={dataUrlToFile}
                files={unassignedAndSelected}
                receptionBox={receptionBox}
                selectedUnattachedFile={selectedUnattachedFile}
                participation={participation}
                open={addNewDocModalOpen}
                setOpen={setAddNewDocModalOpen}
                updateData={props.updateData}
                persons={notDeletedPersons}
                showLoader={showLoader}
                hideLoader={hideLoader}
                getSupportingDocumentTypeByPerson={getSupportingDocumentTypeByPerson}
                typeLabel={typeLabel}
                categoryLabel={categoryLabel}
                getCategory={getCategory}
                quadralToast={props.quadralToast}
            />
            <AICheckModal
                open={aiCheckModal}
                setOpen={setAICheckModal}
                quadralToast={props.quadralToast}
                participationId={participation?.id} 
                participationStatus={participation?.status}
                setAllVialinkChecked={setAllVialinkChecked}
            />
            <QuadralContainer orientation='column' sx={{height: '100%'}}>
            <QuadralContainer orientation='right' sx={{flexShrink: 0, gap: '0.625rem'}}>
                <QuadralButton
                    label="Envoyer le formulaire au format papier"
                    color="secondary"
                    startIcon={<FontAwesomeIcon style={{fontSize: '16px', color: themeColors.icon.color}} icon={faEnvelope}/>}
                    disabled={!(participation?.status !== "annulee" && participation?.status !== "controlee" && participation?.status !== "reponse_validee" && participation?.status !== "supprimee")}
                    onClick={() => setSendMailModalOpen(true)}>
                </QuadralButton>
                <div style={{display: 'flex', justifyContent:'flex-end'}} >
                    <QuadralButton 
                        label="Modifier la participation"
                        color="secondary" 
                        startIcon={<FontAwesomeIcon style={{fontSize: '16px', color: themeColors.icon.color}} icon={faPencil}/>}
                        disabled={!participation?.uniqueContractCode}
                        onClick={() => impersonateToCandidate()}
                    />
                </div>
                {!props.participationVerified ? (
                    <QuadralButton
                        disabled={!props.canUpdate}
                        onClick={() => props.setIsTerminationModalOpen(true)}
                    >
                        Terminer la vérification
                    </QuadralButton>
                ) : (
                    <QuadralButton
                        disabled={true}
                    >
                        Participation vérifiée
                    </QuadralButton>
                )}
            </QuadralContainer>
            <QuadralContainer orientation='row' sx={{height: '100%', flex: 1, minHeight: 0}}>
                <QuadralContainer style={{
                    display: 'flex',
                    flexDirection: 'column',
                    pointerEvents: displayDocumentList ? "auto" : "none",
                    transition: "max-width 0.5s ease-in-out",
                    borderRight: displayDocumentList ? '2px solid #C7D2FE' : 'none',
                    borderRadius: '0',
                    maxWidth: displayDocumentList ? "27%" : "0%",
                    maxHeight: '100%',
                }}>
                    <div style={{paddingBottom: '1rem', borderBottom: '2px solid #C7D2FE', flexShrink: 0}}>
                        <QuadralContainer orientation='row' sx={{alignItems: 'center'}}>
                            {displayDocumentList && (
                                <QuadralButtonIcon
                                    icon={<FontAwesomeIcon icon={faBars}/>}
                                    style={{
                                        maxWidth: displayDocumentList ? "100%" : "10%",
                                        cursor: "pointer",
                                        pointerEvents: receptionBoxDisplay ? "none" : "auto"
                                    }}
                                    disabled={receptionBoxDisplay}
                                    onClick={collapseToggle}
                                />
                            )}
                            <QuadralTypography variant='cardTitle' style={{
                                opacity: displayDocumentList ? "1" : "0",
                                transition: "opacity 0.4s ease-in-out"
                            }}>
                                Pièces justificatives
                            </QuadralTypography>
                        </QuadralContainer>
                    </div>
                    <QuadralLoaderProvider/>
                        <QuadralContainer style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%', 
                            overflow: 'auto',
                            opacity: displayDocumentList ? "1" : "0",
                            transition: "max-width 0.4s ease-in-out, opacity 0.4s ease-in-out",
                            padding: '1rem',
                            flex: 1, 
                            minHeight: 0
                        }}>
                            <SupportingDocumentList
                                receptionBoxDisplay={receptionBoxDisplay}
                                isAnySelected={isAnySelected}
                                data={data}
                                getStatus={getStatus}
                                getStatusIcon={getStatusIcon}
                                getCategory={getCategory}
                                getPersonGenre={getPersonGenre}
                                getPersonName={getPersonName}
                                selectedCurrentPerson={selectedCurrentPerson}
                                selectedIndex={selectedIndex}
                                displayDocumentList={displayDocumentList}
                                displayDocumentDetail={displayDocumentDetail}
                                setAddDocModalOpen={setAddDocModalOpen}
                                setAddNewDocModalOpen={setAddNewDocModalOpen}
                                setAssociationDisplay={setAssociationDisplay}
                                emptyRefusalModal={emptyRefusalModal}
                                hasReceptionFiles={hasReceptionFiles}
                                showAssociateButton={showAssociateButton}
                                showAIVerification={showAIVerification}
                                allVialinkChecked={allVialinkChecked}
                                checkByAI={checkByAI}
                                setShowAssociateButton={setShowAssociateButton}
                                showLoader={showLoader}
                                hideLoader={hideLoader}
                            />
                        </QuadralContainer>
                </QuadralContainer>
                <QuadralContainer orientation='column' style={{
                    maxWidth: displayDocumentList ? "73%" : "100%",
                    transition: "max-width 0.5s ease-in-out",
                    paddingLeft: displayDocumentList ? '1rem' : '0',
                    paddingTop: '1rem',
                    gap: '10px'
                }}>
                    {receptionBoxDisplay ? (
                        <ReceptionBox
                            completedRows={completedRows}
                            makePageId={makePageId}
                            allSelected={allSelected}
                            allUnassignedDocs={allUnassignedDocs}
                            toggleSelectAll={toggleSelectAll}
                            confirmAssignation={confirmAssignation}
                            receptionBox={receptionBox}
                            selectedFileByDoc={selectedFileByDoc}
                            showAssociateButton={showAssociateButton}
                            setSelectedFileByDoc={setSelectedFileByDoc}
                            setRotatedFiles={setRotatedFiles}
                            selectedUnattachedFile={selectedUnattachedFile}
                            handlePageSelection={handlePageSelection}
                            cancel={handleCancel}
                            docIndex={selectedIndex}
                            statuses={props?.statuses}
                            dataUrlToFile={dataUrlToFile}
                            getDocStatusCount={props?.getDocStatusCount}
                            participationVerified={props?.participationVerified}
                            setIsTerminationModalOpen={props?.setIsTerminationModalOpen}
                            participationId={participation?.id}
                            showLoader={showLoader}
                            hideLoader={hideLoader}
                        />
                    ) : (
                        <SupportingDocumentDetail
                            canUpdate={props?.canUpdate}
                            supportingDocsOnlyTotal={supportingDocsOnly?.length}
                            quadralToast={props.quadralToast}
                            participationVerified={props?.participationVerified}
                            setIsTerminationModalOpen={props?.setIsTerminationModalOpen}
                            updatedData={updatedData}
                            updateData={props.updateData}
                            document={selectedDocument}
                            documentTotal={flatenedData.length}
                            persons={props?.persons}
                            getType={getType}
                            getStatus={getStatus}
                            getStatusIcon={getStatusIcon}
                            getCategory={getCategory}
                            getPersonGenre={getPersonGenre}
                            getPersonName={getPersonName}
                            getPersonBirthDate={getPersonBirthDate}
                            getPersonNationality={getPersonNationality}
                            getPersonVialinkControlResponse={getPersonVialinkControlResponse}
                            selectedCurrentPerson={selectedCurrentPerson}
                            onNext={handleNext}
                            onPrevious={handlePrevious}
                            showLoader={showLoader}
                            hideLoader={hideLoader}
                            displayDocumentList={displayDocumentList}
                            collapseToggle={collapseToggle}
                            personId={selectedDocument?.personId}
                            id={props?.id}
                            participation={participation}
                            files={files}
                            setFiles={setFiles}
                            showRefuseModal={showRefuseModal}
                            setShowRefuseModal={setShowRefuseModal}
                            status={status}
                            setStatus={setStatus}
                            statusIcon={statusIcon}
                            setStatusIcon={setStatusIcon}
                            refuseFormData={refuseFormData}
                            setRefuseFormData={setRefuseFormData}
                            updateSupportingDocument={updateSupportingDocument}
                            getDocStatusCount={props?.getDocStatusCount}
                            emptyRefusalModal={emptyRefusalModal}
                            refreshPersonsData={props?.refreshPersonsData}
                        />
                    )}
                </QuadralContainer>
            </QuadralContainer>
            </QuadralContainer>
        </>
    );
}